import React, { Suspense, useEffect } from 'react';
import { colors, getPiChartConfig } from './helper';
import { WidgetLayout } from '../shared/WidgetLayout/WidgetLayout';
import { WithMarkdown } from '../shared/WithMarkdown/WithMarkdown';
import { Box } from '@wix/design-system';
import { useDisabledWidget } from '../../../shared/disabled-widget/useDisabledWidget';
const Doughnut = /*#__PURE__*/React.lazy(() => import('react-chartjs-2').then(module => ({
  default: module.Doughnut
})));
export const ChartWidget = _ref => {
  let {
    data,
    context,
    config
  } = _ref;
  const {
    areControlsDisabled,
    enableControls
  } = useDisabledWidget(config);
  const {
    pieSlices,
    description,
    footerButtonsAsColumn,
    primaryButton,
    secondaryButton,
    text,
    chartType = 'doughnut'
  } = data;
  useEffect(() => {
    import('chart.js').then(_ref2 => {
      let {
        ArcElement,
        Tooltip,
        Legend,
        Chart
      } = _ref2;
      Chart.register(ArcElement, Tooltip, Legend);
    });
  }, []);
  const handleButtonClick = function (action, label) {
    if (label === void 0) {
      label = '';
    }
    const handler = effects => {
      const onWidgetActionData = {
        action,
        value: {
          label,
          effects
        }
      };
      context.onWidgetAction(CHART_WIDGET, onWidgetActionData, text);
    };
    return handler;
  };
  const maxLabels = 4;
  const totalValue = (pieSlices || []).reduce((sum, item) => sum + item.value, 0);
  const shouldShowOther = (pieSlices || []).length > 3;
  const limitedData = (pieSlices || []).slice(0, maxLabels - 1);
  const otherValue = shouldShowOther ? totalValue - limitedData.reduce((sum, item) => sum + item.value, 0) : 0;
  const labels = limitedData.map(item => item.label);
  if (shouldShowOther) {
    labels.push('Other');
  }
  const dataValues = [...limitedData.map(item => item.value)];
  if (shouldShowOther) {
    dataValues.push(otherValue);
  }
  const chartData = {
    labels,
    datasets: [{
      data: dataValues,
      backgroundColor: colors,
      hoverBackgroundColor: colors
    }]
  };
  const piChartConfig = getPiChartConfig(chartData, chartType);
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement("div", null, "Loading Chart...")
  }, /*#__PURE__*/React.createElement(WidgetLayout, {
    text: text,
    secondaryButton: secondaryButton,
    primaryButton: primaryButton,
    context: context,
    onSecondaryButtonClick: handleButtonClick('secondary_button_click', secondaryButton == null ? void 0 : secondaryButton.label),
    onPrimaryButtonClick: handleButtonClick('primary_button_click', primaryButton == null ? void 0 : primaryButton.label),
    footerButtonsAsColumn: footerButtonsAsColumn,
    disabled: areControlsDisabled,
    onEnableControls: enableControls
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP1"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      textAlign: 'center',
      width: '100%',
      height: '100%'
    }
  }, /*#__PURE__*/React.createElement(Doughnut, {
    data: chartData,
    options: piChartConfig.options,
    width: 189,
    height: 189
  })), description && /*#__PURE__*/React.createElement(WithMarkdown, null, description))));
};
export const CHART_WIDGET = 'CHART_WIDGET';
//# sourceMappingURL=ChartWidget.js.map